/*** IMPORTS FROM imports-loader ***/
var define = false;

'use strict';

/** @type {import('./abs')} */
module.exports = Math.abs;

